import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const productGallery = () => {
  let swiper = null;
  let swiperThumbnails = null;
  const buybox = document.querySelector('.js-buybox');
  if (!buybox) return;
  const prevButton = buybox.querySelector('.thumbs-slider-button-left');
  const nextButton = buybox.querySelector('.thumbs-slider-button-right');

  const init = () => {
    initializeThumbnails();
    initializeGallery();
    disableButton();
  };

  const initializeThumbnails = () => {
    const thumbnailElement = buybox.querySelector(
      '.js-gallery-thumbnails-swiper',
    );
    if (!thumbnailElement) return;

    swiperThumbnails = new Swiper(thumbnailElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        340: {
          slidesPerView: 6,
          direction: 'horizontal',
          spaceBetween: 8,
          centeredSlides: false,
          initialSlide: 0,
        },
        768: {
          slidesPerView: 'auto',
          direction: 'vertical',
          centeredSlides: false,
        },
      },
    });

    swiperThumbnails.on('click', (e) => {
      const target = e.target?.closest('button');

      if (target) {
        swiper.slideTo(swiperThumbnails.clickedIndex);
      }
    });

    thumbnailElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const targetSlide = e.target.closest('.swiper-slide');
        if (targetSlide) {
          const index = Array.from(swiperThumbnails.slides).indexOf(
            targetSlide,
          );
          if (index >= 0) {
            e.preventDefault();
            swiper.slideTo(index);
          }
        }
      }
    });
  };

  const initializeGallery = () => {
    const galleryElement = buybox.querySelector('.js-gallery-swiper');
    if (!galleryElement) return;

    swiper = new Swiper(galleryElement, {
      slidesPerView: 1,
      mousewheel: {
        forceToAxis: true,
      },
      thumbs: {
        swiper: swiperThumbnails,
      },
      navigation: {
        nextEl: '.slider-button-right',
        prevEl: '.slider-button-left',
        disabledClass: 'pointer-events-none opacity-0',
      },
      on: {
        slideChange: () => {
          syncThumbnails();
          disableButton();
        },
      },
    });
  };

  const syncThumbnails = () => {
    // Ensure the corresponding thumbnail is fully visible
    const activeIndex = swiper.activeIndex;
    if (swiperThumbnails) {
      swiperThumbnails.slideTo(activeIndex);
      swiperThumbnails.slides.forEach((slide, index) => {
        slide.classList.toggle(
          'swiper-slide-thumb-active',
          index === activeIndex,
        );
      });
    }
  };

  nextButton?.addEventListener('click', () => {
    swiper.slideNext();
    disableButton();
  });

  prevButton?.addEventListener('click', () => {
    swiper.slidePrev();
    disableButton();
  });

  const disableButton = () => {
    const disabledClasses = ['pointer-events-none', 'opacity-0'];
    const totalSlides = swiper.slides.length;

    const isLastSlide = swiper.activeIndex === totalSlides - 1;
    const isPrevDisabled =
      swiper.activeIndex === 0 && swiper.slides.length >= 6;

    // Disable or enable buttons dynamically
    disabledClasses.forEach((className) => {
      nextButton?.classList.toggle(className, isLastSlide); // Disable 'next' on last slide
      prevButton?.classList.toggle(className, isPrevDisabled); // Disable 'prev' on first or >= 6
    });
  };

  return {
    init,
  };
};
